import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Spinner from "../../../components/spinner";
import useGetBusinessAccountApplications from "../../../hooks/customers/useGetBusinessAccountApplications";
import { checkIfEmpty, convertToSentenceCase } from "../../../utilities";
import Errors from "../../errors";
import ApproveRejectModal from "../../../components/business-applications/ApproveRejectModal";
import Pagination from "../../../components/elements/pagination";

const BusinessApplicationsList = () => {
  const navigate = useNavigate();
  const {
    applicationList,
    isLoading,
    status,
    error,
    pagination,
    handlePageClick,
    debouncedSearch,
  } = useGetBusinessAccountApplications();

  const [selectedApplication, setSelectedApplication] = useState(null);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);

  const handleApprove = (application) => {
    setSelectedApplication(application);
    setShowApproveModal(true);
  };

  const handleReject = (application) => {
    setSelectedApplication(application);
    setShowRejectModal(true);
  };

  const handleViewDetails = (applicationId) => {
    navigate(`/customers/business-applications/${applicationId}`);
  };

  return (
    <div className="category  px-5">
      {showApproveModal && (
        <ApproveRejectModal
          isApprove={true}
          isOpen={showApproveModal}
          handleClose={() => setShowApproveModal(false)}
          application={selectedApplication}
          refreshUrl="business/list"
        />
      )}
      {showRejectModal && (
        <ApproveRejectModal
          isApprove={false}
          isOpen={showRejectModal}
          handleClose={() => setShowRejectModal(false)}
          application={selectedApplication}
          refreshUrl="business/list"
        />
      )}
      <div className="category__head headingBorder__b">
        <h2 className="titleHeading">Business Applications</h2>
      </div>
      <div className="category_table py-5 space-y-5">
        <div className="flex items-center space-x-4">
          <div className="flex-1">
            <input
              name="searchQuery"
              onChange={(e) => debouncedSearch(e.target.value)}
              type="text"
              placeholder="Search applications...."
              className="input "
            />
          </div>
        </div>
        {isLoading ? (
          <Spinner />
        ) : status === "error" ? (
          <Errors errorObject={error} inline />
        ) : (
          <>
            <div className="overflow-auto bg-white rounded-lg shadow relative w-full">
              <table className="border-collapse table-auto w-full whitespace-no-wrap bg-white table-striped relative">
                <thead>
                  <tr className="text-left">
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                      Name
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs min-w-[10rem]">
                      Business Name
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                      Business Email
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                      Business Phone
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                      Category
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                      Is email verified
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                      Approval status
                    </th>
                    <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {applicationList?.map((el, idx) => {
                    const {
                      id,
                      business_application_id,
                      first_name,
                      last_name,
                      business_name,
                      business_email,
                      business_phone,
                      business_category,
                      business_address1,
                      business_city,
                      business_state,
                      business_pincode,
                      is_email_verified,
                      approval_status,
                      business_id,
                    } = el || {};
                    const applicationId = business_id;
                    return (
                      <tr>
                        <td className="border-dashed border-t border-gray-200 userId">
                          <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                            {first_name} {last_name}
                          </span>
                        </td>
                        <td className="border-dashed border-t border-gray-200 userId">
                          <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                            {business_name}
                          </span>
                        </td>
                        <td className="border-dashed border-t border-gray-200 userId">
                          <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                            {business_email}
                          </span>
                        </td>
                        <td className="border-dashed border-t border-gray-200 userId">
                          <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                            {business_phone}
                          </span>
                        </td>
                        <td className="border-dashed border-t border-gray-200 userId">
                          <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                            {business_category || "---"}
                          </span>
                        </td>
                        <td className="border-dashed border-t border-gray-200 userId">
                          <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                            {is_email_verified ? "Yes" : "No"}
                          </span>
                        </td>
                        <td className="border-dashed border-t border-gray-200 userId">
                          <span className="text-gray-700 px-6 py-3 flex items-center text-sm">
                            {convertToSentenceCase(approval_status)}
                          </span>
                        </td>
                        <td className="border-dashed border-t border-gray-200 userId">
                          <div className="flex items-center gap-2 pr-2 flex-wrap py-2">
                            <button
                              onClick={() => handleViewDetails(applicationId)}
                              className="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-medium text-slate-700 bg-gradient-to-r from-slate-100 to-slate-200 hover:from-slate-200 hover:to-slate-300 border border-slate-300 rounded-lg shadow-sm transition-all duration-200 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-1"
                            >
                              <svg
                                className="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                />
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                />
                              </svg>
                              View
                            </button>
                            {is_email_verified ? (
                              <>
                                {["rejected", "pending"].includes(
                                  approval_status
                                ) && (
                                  <button
                                    onClick={() => handleApprove(el)}
                                    className="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-medium text-emerald-700 bg-gradient-to-r from-emerald-100 to-emerald-200 hover:from-emerald-200 hover:to-emerald-300 border border-emerald-300 rounded-lg shadow-sm transition-all duration-200 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:ring-offset-1"
                                  >
                                    <svg
                                      className="w-4 h-4"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M5 13l4 4L19 7"
                                      />
                                    </svg>
                                    Approve
                                  </button>
                                )}
                                {["approved", "pending"].includes(
                                  approval_status
                                ) && (
                                  <button
                                    onClick={() => handleReject(el)}
                                    className="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-medium text-rose-700 bg-gradient-to-r from-rose-100 to-rose-200 hover:from-rose-200 hover:to-rose-300 border border-rose-300 rounded-lg shadow-sm transition-all duration-200 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-rose-400 focus:ring-offset-1"
                                  >
                                    <svg
                                      className="w-4 h-4"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M6 18L18 6M6 6l12 12"
                                      />
                                    </svg>
                                    Reject
                                  </button>
                                )}
                              </>
                            ) : (
                              <div className="inline-flex items-center gap-1.5 px-3 py-2 text-xs font-medium text-orange-700 bg-gradient-to-r from-orange-100 to-orange-200 border border-orange-300 rounded-lg">
                                <svg
                                  className="w-4 h-4"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.863-.833-2.634 0L4.168 15.5c-.77.833.192 2.5 1.732 2.5z"
                                  />
                                </svg>
                                Email verification required
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            {applicationList?.length === 0 && (
              <p className="py-16 text-center w-full">No applications found.</p>
            )}
            <Pagination
              currentPage={pagination.page_no}
              lengthofItems={pagination.total_count}
              limit={pagination.per_page}
              onPageChange={handlePageClick}
              pageCount={Math.ceil(
                (pagination.total_count || 0) / (pagination.per_page || 1)
              )}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default BusinessApplicationsList;
